import { faXmark } from "@fortawesome/pro-regular-svg-icons";

import { HistorySingleEntry } from "src/cases/caseView/history/HistoryItemFrame";
import { useGetCaseTemplateTask } from "src/cases/caseView/hooks";
import { useCase } from "src/cases/queries/cases";
import { CaseHistoryEvent } from "src/cases/queries/casesTypes";
import { Pill } from "src/design-system/Pill";
import { CasePageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const TaskUncompleted: React.FC<{
  entry: CaseHistoryEvent<"task_uncompleted">;
  isLast: boolean;
}> = ({ entry, isLast }) => {
  const { case_id: caseId } = useParamsDecode<CasePageParams>();
  const { data: caseData } = useCase(caseId);
  const getCaseTemplateTask = useGetCaseTemplateTask(caseData);

  const { task_key } = entry.event_data;
  const templateTask = getCaseTemplateTask(task_key);
  const taskDisplayName = templateTask?.display_name || task_key;

  return (
    <HistorySingleEntry
      actorId={entry.user_id}
      eventType={entry.event_type}
      headline={
        <>
          <Pill size="sm" variant="gray">
            <Pill.Text>{taskDisplayName}</Pill.Text>
          </Pill>{" "}
          task was marked as incomplete.
        </>
      }
      icon={faXmark}
      isLast={isLast}
      timestamp={entry.timestamp}
    />
  );
};
